import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IconBell, IconUser, IconLogout } from '@tabler/icons-react';
import { useAuth } from '@monorepo/shared-auth';
import sports from '../../../data/sports';
import SportIcon from '../../common/SportIcon/SportIcon';

const Navigation = () => {
  const [showSportsMenu, setShowSportsMenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, userProfile, logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/ubunited', label: 'UBUnited' },
    { path: '/software', label: 'Software Solutions' },
    { path: '/leagues', label: 'Leagues' },
    { path: '/pricing', label: 'Pricing' }
  ];

  return (
    <nav className="ub-navigation">
      <div className="ub-nav-container">
        <Link to="/" className="ub-nav-logo">
          <img
            src="/whiteUbsportsLogo.png"
            alt="UBsports Logo"
            className="ub-logo-image"
          />
        </Link>

        <div className={`ub-nav-menu ${mobileMenuOpen ? 'ub-active' : ''}`}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`ub-nav-link ${isActive(item.path) ? 'ub-active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}

          {/* Sports dropdown hidden for now - keeping code for future use
          <div
            className="ub-nav-link ub-sports-dropdown"
            onMouseEnter={() => setShowSportsMenu(true)}
            onMouseLeave={() => setShowSportsMenu(false)}
          >
            <span>Sports</span>
            {showSportsMenu && (
              <div className="ub-dropdown-menu">
                {sports.map((sport) => (
                  <Link
                    key={sport.id}
                    to={`/sports/${sport.id}`}
                    className="ub-dropdown-item"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <SportIcon iconName={sport.icon} size={20} color={sport.color} />
                    <span>{sport.name}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
          */}
        </div>

        <div className="ub-nav-actions">
          {currentUser ? (
            <>
              <button className="ub-notification-btn" aria-label="Notifications">
                <IconBell strokeWidth={2} />
              </button>
              <div className="ub-user-menu-container">
                <button
                  className="ub-user-greeting"
                  onMouseEnter={() => setShowUserMenu(true)}
                  onMouseLeave={() => setShowUserMenu(false)}
                >
                  <span className="ub-greeting-text">It's Game Time, {userProfile?.firstName || 'Player'}</span>
                  <IconUser className="ub-profile-icon-mobile" size={24} strokeWidth={2} />
                </button>
                {showUserMenu && (
                  <div
                    className="ub-user-dropdown"
                    onMouseEnter={() => setShowUserMenu(true)}
                    onMouseLeave={() => setShowUserMenu(false)}
                  >
                    <Link to="/profile" className="ub-user-dropdown-item">
                      <IconUser size={18} />
                      <span>Profile</span>
                    </Link>
                    <button onClick={handleLogout} className="ub-user-dropdown-item">
                      <IconLogout size={18} />
                      <span>Sign Out</span>
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <Link to="/auth" className="ub-sign-in-btn">
              Sign In
            </Link>
          )}
        </div>

        <button
          className="ub-mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
